import { SelectCheckbox } from '../selectCheckbox/SelectCheckbox'
import styled from 'styled-components'

export const StyledSelectCheckbox = styled(SelectCheckbox)`
  width: 100%;
`
